export const MIN_ZOOM_IN_DURATION = 11.25 * 60 * 1000;
export const MAX_ZOOM_OUT_DURATION = 86400 * 1000;

export enum TimelineRenderTypes {
  TEMPLATING = "templating",
  SCHEDULING = "scheduling",
  EPG = "epg",
}

export const computeItemEndTimeLoopTimeline = ({
  startTime,
  duration,
  minTimeStart,
  maxTimeEnd,
}: {
  startTime: number;
  duration: number;
  minTimeStart: number;
  maxTimeEnd: number;
}): number => {
  const endTime = startTime + duration;

  if (endTime > maxTimeEnd) {
    return minTimeStart + (endTime - maxTimeEnd);
  }

  return endTime;
};

export const computeItemStartTimeLoopTimeline = ({
  endTime,
  duration,
  minTimeStart,
  maxTimeEnd,
}: {
  endTime: number;
  duration: number;
  minTimeStart: number;
  maxTimeEnd: number;
}): number => {
  const startTime = endTime - duration;

  if (startTime < minTimeStart) {
    return maxTimeEnd - (minTimeStart - startTime);
  }

  return startTime;
};
